import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { onBillingBlocked } from '../../utils/billingEvents';
import { BILLING_EMAIL } from '../../utils/billingStatus';
import '../../styles/BillingBlockedModal.css';

const TITLES = {
    billing_inactive: 'New cases are paused',
    seat_limit: 'No seats left',
    no_facility: 'Your account is not linked to an agency',
};

/** Mounted once in App.js. Opens whenever api.js sees a 402 (see billingEvents). */
export default function BillingBlockedModal() {
    const { isFacilityAdmin } = useAuth();
    const [blocked, setBlocked] = useState(null);

    useEffect(() => onBillingBlocked((payload) => setBlocked(payload)), []);
    useEffect(() => {
        if (!blocked) return undefined;
        const onKey = (e) => { if (e.key === 'Escape') setBlocked(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [blocked]);

    if (!blocked) return null;
    const title = TITLES[blocked.code] ?? TITLES.billing_inactive;
    const close = () => setBlocked(null);

    return createPortal(
        <div className="billing-blocked-overlay" onClick={close}>
            <div className="billing-blocked-modal" role="dialog" aria-modal="true" aria-labelledby="billing-blocked-title" aria-describedby="billing-blocked-message" onClick={(e) => e.stopPropagation()}>
                <h2 id="billing-blocked-title">{title}</h2>
                <p id="billing-blocked-message">{blocked.message}</p>
                <p className="billing-blocked-contact">
                    Questions? <a href={`mailto:${BILLING_EMAIL}`}>{BILLING_EMAIL}</a>
                </p>
                <div className="billing-blocked-actions">
                    <button type="button" className="billing-blocked-btn billing-blocked-btn-ghost" onClick={close}>Close</button>
                    {isFacilityAdmin && <Link to="/billing" className="billing-blocked-btn billing-blocked-btn-primary" onClick={close}>Go to Billing</Link>}
                </div>
            </div>
        </div>,
        document.body,
    );
}
